import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = () => {
	const { pathname } = useLocation();
	useEffect(() => {
		const rootElement = document.querySelector('.page');
		if (rootElement) {
			rootElement.scrollTo({ top: 0, behavior: 'instant' });
		}
	}, [pathname]);
	return null;
};
export default ScrollToTop;
